<pr-form
  (onSubmit)="submit()"
  title="Modifier vos objectifs"
  [formGroup]="form"
>
  <pr-input label="Montant de vos liquidités" [derrors]="derrors" suffix="€">
    <input formControlName="liquidity" type="text" />
  </pr-input>

  <pr-input
    label="Montant de votre épargne mensuelle"
    [derrors]="derrors"
    suffix="€/mois"
  >
    <input formControlName="monthlySaving" type="text" />
  </pr-input>

  <pr-input
    label="Montant de votre épargne de précaution"
    [derrors]="derrors"
    suffix="€"
  >
    <input formControlName="epargnePrecaution" type="text" />
  </pr-input>

  <pr-input-icon-multiselect
    formControlName="investmentGoals"
    label="Vos objectifs"
    [derrors]="derrors"
    [options]="reference"
  ></pr-input-icon-multiselect>
</pr-form>
